import React, { useState } from "react";
import { carrierInitials } from "../carrierHelpers";

const MIN_LOGO_WIDTH = 32;

const SIZES = {
  lg: "h-11 w-[76px] rounded-lg text-xs",
  md: "h-[38px] w-[60px] rounded-lg text-[10px]",
  sm: "h-8 w-14 rounded-md text-[10px]",
};

const TONES = {
  brand: "bg-brand-light text-brand",
  muted: "bg-ui-surface-sunken text-ui-text-muted",
};

const CarrierLogo = ({ src, name, code, size = "lg", tone = "brand", dimmed = false }) => {
  const [failedSrc, setFailedSrc] = useState(null);
  const showImage = src && failedSrc !== src;

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden border border-ui-border font-bold transition-opacity ${
        SIZES[size]
      } ${dimmed ? "opacity-[0.45]" : ""} ${showImage ? "bg-white p-1" : TONES[tone]}`}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          referrerPolicy="no-referrer"
          onLoad={(e) => e.currentTarget.naturalWidth < MIN_LOGO_WIDTH && setFailedSrc(src)}
          onError={() => setFailedSrc(src)}
          className="h-full w-full object-contain"
        />
      ) : (
        code ?? carrierInitials(name)
      )}
    </div>
  );
};

export default CarrierLogo;
